export const AlignLeftIcon = {
  default: {
    a: {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
    },
    path: [
      {
        d: "M5.5 5V19",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
      {
        d: "M8 7H22V11H8V7Z",
        fill: "currentColor",
      },
      {
        d: "M8 13H14V17H8V13Z",
        fill: "currentColor",
      },
    ],
  },
};
